
import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineSupportAgent,
  MdCurrencyRupee,
} from "react-icons/md";
import { SiNeteasecloudmusic } from "react-icons/si";
import { Card, Container } from "react-bootstrap";
import { TfiWallet } from "react-icons/tfi";
import { IoMdRefresh } from "react-icons/io";
import { AiFillSound } from "react-icons/ai";
import { FaGripfire } from "react-icons/fa";
import { fetchwalletamount } from "../../../common";
import { decryptData, encryptData } from "../../../decryptHelper";

export default function WingoChart({ message }) {
  const user_id = localStorage.getItem("userid");
  const devid = localStorage.getItem("dev_id");

  const isLoading = useRef(false);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState(null);
  const [credit, updateCredit] = useState(null);
  const [walletAmount, setWalletAmount] = useState(null);

  const navigate = useNavigate();

  const fetchGames = useCallback(async () => {
    if (isLoading.current) return;

    isLoading.current = true;
    setLoading(true);

    try {
      const apiUrl = `${process.env.REACT_APP_API_URL_NODE}user-profile`;

      const requestData = {
        app_id: process.env.REACT_APP_API_ID,
        user_id: user_id,
        device_id: devid,
      };

      const encryptedText = encryptData(requestData);

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ data: encryptedText }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data1 = await response.json();

      if (!data1?.encryptedResponse) {
        throw new Error("Encrypted response not found");
      }

      const data = decryptData(data1.encryptedResponse);

      if (data?.is_login === "0") {
        window.location.href = "/";
        return;
      }

      if (data?.success === "1") {
        setUserData(data);
        updateCredit(data?.data?.credit ?? 0);
      } else {
        console.error("API Error:", data?.message);
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
    } finally {
      isLoading.current = false;
      setLoading(false);
    }
  }, [user_id, devid]);

  // Fetch wallet amount using common function
  const loadWalletAmount = useCallback(() => {
    try {
      fetchwalletamount(setWalletAmount);
    } catch (error) {
      console.error("Wallet amount error:", error);
    }
  }, []);

  // Initial fetch and refresh every 5 seconds
  useEffect(() => {
    fetchGames();
    loadWalletAmount();

    const interval = setInterval(() => {
      fetchGames();
      loadWalletAmount();
    }, 5000);

    return () => clearInterval(interval);
  }, [fetchGames, loadWalletAmount, message]);

  const formatAmount = (amount) => {
    // Supports a number or common object response formats
    const value =
      typeof amount === "object" && amount !== null
        ? amount.amount ?? amount.balance ?? amount.credit ?? 0
        : amount;

    const number = Number(value);

    return (Number.isFinite(number) ? number : 0).toFixed(2);
  };

  const Depositshow = () => {
    localStorage.setItem("deps", "true");
    navigate("/Deposit");
  };

  return (
    <section className="wingoheader">
      <div className="wingo padding_all">
        <div className="allbefore position-relative">
          <Container>
            <Card className="mt-2 points_left_right">
              <Card.Body className="bg_color_all_wingo">
                {/* Profile credit balance */}
                {/* <h3 className="text-white d-flex mb-0 align-items-center gap-1 justify-content-center">
                  <MdCurrencyRupee />
                  {formatAmount(credit)}
                  <IoMdRefresh
                    className="text-secondary"
                    style={{
                      cursor: "pointer",
                      animation: loading ? "spin 1s linear infinite" : "none",
                    }}
                    onClick={() => {
                      fetchGames();
                      loadWalletAmount();
                    }}
                  />
                </h3> */}

                {/* <p className="d-flex text-white mb-2 align-items-center gap-1 justify-content-center">
                  <TfiWallet />
                  Profile Balance
                </p> */}

                {/* fetchwalletamount balance */}
                <h3 className="text-white d-flex mb-0 align-items-center gap-1 justify-content-center">
                  <MdCurrencyRupee />
                  {formatAmount(walletAmount)}
                  <IoMdRefresh
                    className="text-secondary"
                    style={{ cursor: "pointer" }}
                    onClick={loadWalletAmount}
                  />
                </h3>

                <p className="d-flex text-white mb-0 align-items-center gap-1 justify-content-center">
                  <TfiWallet />
                  Wallet Balance
                </p>
              </Card.Body>
            </Card>

            <div className="Marquee_Tag">
              <div className="d-flex justify-content-between align-items-center">
                <div className="h-25 w-28 sound_icon">
                  <AiFillSound />
                </div>

                <div className="Notice">
                  <p style={{ color: "white" }}>
                    Our customer service never sends a link to the member. If
                    you received a link from someone who proclaimed as customer
                    service, do not click the link to prevent being hacked or
                    losing data. Thank you
                  </p>
                </div>

                <div className="details">
                  <Link to="/Details" style={{ textDecoration: "none" }}>
                    <button className="align-items-center d-flex">
                      <FaGripfire />
                      Details
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </div>
    </section>
  );
}
